/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserType } from './UserType';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    UserTypeToJSONTyped,
} from './UserType';

/**
 * 
 * @export
 * @interface UserAliasResponse
 */
export interface UserAliasResponse {
    /**
     * 
     * @type {string}
     * @memberof UserAliasResponse
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserAliasResponse
     */
    derivedUserId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserAliasResponse
     */
    firstname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserAliasResponse
     */
    surname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserAliasResponse
     */
    mail?: string | null;
    /**
     * 
     * @type {UserType}
     * @memberof UserAliasResponse
     */
    userType?: UserType;
    /**
     * 
     * @type {boolean}
     * @memberof UserAliasResponse
     */
    isIdPortenUser?: boolean;
}



/**
 * Check if a given object implements the UserAliasResponse interface.
 */
export function instanceOfUserAliasResponse(value: object): value is UserAliasResponse {
    return true;
}

export function UserAliasResponseFromJSON(json: any): UserAliasResponse {
    return UserAliasResponseFromJSONTyped(json, false);
}

export function UserAliasResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAliasResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] === undefined ? undefined : json['id'] === null ? null : json['id'],
        'derivedUserId': json['derivedUserId'] === undefined ? undefined : json['derivedUserId'] === null ? null : json['derivedUserId'],
        'firstname': json['firstname'] === undefined ? undefined : json['firstname'] === null ? null : json['firstname'],
        'surname': json['surname'] === undefined ? undefined : json['surname'] === null ? null : json['surname'],
        'mail': json['mail'] === undefined ? undefined : json['mail'] === null ? null : json['mail'],
        'userType': json['userType'] == null ? undefined : UserTypeFromJSON(json['userType']),
        'isIdPortenUser': json['isIdPortenUser'] == null ? undefined : json['isIdPortenUser'],
    };
}

export function UserAliasResponseToJSON(json: any): UserAliasResponse {
    return UserAliasResponseToJSONTyped(json, false);
}

export function UserAliasResponseToJSONTyped(value?: UserAliasResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'derivedUserId': value['derivedUserId'],
        'firstname': value['firstname'],
        'surname': value['surname'],
        'mail': value['mail'],
        'userType': UserTypeToJSON(value['userType']),
        'isIdPortenUser': value['isIdPortenUser'],
    };
}

